/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiCbpHts.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-cbp-hts";

export class AutogenModelEdiCbpHts<RowType extends ModelRow> extends Endpoint<RowType, RowEdiCbpHtsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiCbpHts extends ModelRow<RowEdiCbpHtsFields> {
	constructor(values?: Partial<RowEdiCbpHtsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiCbpHtsFields {
	col_1_rate: string;
	col_2_rate: string;
	company_id: string;
	description: string;
	footnote: string;
	hts_level: number;
	hts_no: string;
	misc: string;
	quantity_unit: string;
	special_rate: string;
	stat_suffix: string;
}

